import { useEffect } from 'react';
import { Typography, Dialog, DialogTitle, DialogActions, DialogContent, Button, Divider, Alert, Box, Link, Select, MenuItem, TextField, FormControl } from "@mui/material";
import { FlexGrid } from '@albo-ui/core';
import { closelightbox } from "../../../util/Functions";
import { ModalStyle } from "../../../util/Styles";
import { useGenerateInfo } from "./hooks/useGenerateInfo";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import alert from '../../../images/alert.png'
import SnackbarContent from '@mui/material/SnackbarContent';

const GenerateTxInfo = ({ open, changeAlert, changeLoader }) => {
    const { form, error, isValidForm, zPos, dropZoneRef, execute, onSelectFile, onConfirm, handleOver, handleLeave, handleDrop, onFormReset, setExecute, onHandleChange } = useGenerateInfo(open, changeAlert, changeLoader);
    
    const action = (
        <Button size="small" variant="text" id='buttonText' onClick={onFormReset}>Cambiar</Button>
    );

    const addFile = () => {
        document.getElementById("file")?.click();
    };

    useEffect(() => {
        document && addFile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [document]);

    return (
        <Dialog open={true} fullWidth sx={{ zIndex: zPos, filter: zPos !== 45 ? "blur(2px)" : "none" }}>
            <ModalStyle property={String(isValidForm)}>
                <DialogTitle>
                    <span>Descarga de Archivos - SPEI</span>
                </DialogTitle>

                <DialogContent>
                    {
                        <>
                        {!execute && <Alert severity={"info"}>Indique el tipo de descarga</Alert>}
                        <Select value={execute || '-1'} onChange={(e) => setExecute(e.target.value)} MenuProps={{style: {zIndex: 35001}}} sx={{mt: 2, mb: 1}} fullWidth variant="outlined" size='small' >
                            <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
                            <MenuItem value={"dates"}>Descarga por Rango de fechas</MenuItem>
                            <MenuItem value={"file"}>Descarga por CSV</MenuItem>
                        </Select>
                        </>
                    }

                    {   execute === "file" &&
                        <Alert severity={"info"}>
                            El archivo solo debe contener una columna con las CLABES. No requiere encabezado.
                        </Alert>
                    }

					<Divider sx={{mt: 2}} />
                    {  execute === "file" && (form && form["file_name"] ?
                        <Box sx={{mb: 1, textAlign: "center"}} display={"flex"}>
                            <Box component="img" alignSelf={"center"} alt="emptyList" src={alert} width={150}/>
                            <Box py={3} pl={2} alignContent={"center"}>
                                <SnackbarContent message={form["file_name"]} action={action} sx={{backgroundColor: "cadetblue", mb: 3, fontWeight: 800}} />
                                <Typography variant="body2">Realizarás la descarga de <b>{form["lines"].length} registros</b></Typography>
                                <Typography variant="body2">¿Deseas continuar?</Typography>
                            </Box>
                        </Box> 
                        :
                        <>
                        <Box 
                            ref={dropZoneRef} onDragLeave={handleLeave} onDragOver={handleOver} onDrop={handleDrop} onClick={addFile.bind(this, "")}
                            sx={{p: 3, mb: 1, mt: 3, border: "4px dashed lightgray", textAlign: "center", cursor: "pointer"}}>
                            <CloudUploadIcon fontSize="large" color="action" sx={{m: 1}}/>
                            <Typography variant="body2">
                                Arrastra y suelta tu archivo o <Link >cárgalo desde tus documentos</Link>
                            </Typography>
                            <input id="file" type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
                        </Box>
                        <Typography variant="body2">Formatos válidos: .csv .xls y .xlsx.</Typography>
                        </>
                    )}
                    { execute === "dates" && 
                        <Box display={"flex"} pt={3} gap={2}>
                        <FlexGrid item fullWidth>
                            <FormControl color='secondary' fullWidth >
                            <TextField
                                value={(form && form["fechaInicio"]) || "" }
                                onChange={onHandleChange.bind(this, 'fechaInicio')}
                                label="Fecha inicio"
                                size="small"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{style: {height: 40}}} 
                            />
                            
                            </FormControl>
                        </FlexGrid>
                        <FlexGrid item fullWidth>
                            <FormControl color='secondary' fullWidth >
                            <TextField
                                value={(form && form["fechaFin"]) || "" }
                                onChange={onHandleChange.bind(this, 'fechaFin')}
                                label="Fecha fin"
                                size="small"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{style: {height: 40}}} 
                            />
                            </FormControl>
                        </FlexGrid>
                        </Box>
                    }

                    {error && <Typography variant="body2" color="orangered">{error}</Typography>}
                </DialogContent>

                <DialogActions>
                    <Button onClick={closelightbox} variant="outlined" id='buttonCancel'>
                        Cancelar
                    </Button>
                    <Button onClick={onConfirm.bind(this)} disabled={isValidForm} variant="contained">
                        Continuar
                    </Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
};

export default GenerateTxInfo;
